import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions';

import RegistrationForm from './RegistrationForm';

class RegistrationPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      registration: {
        email: '',
        emailConfirm: '',
        password: '',
        passwordConfirm: '',
        errors: []
      }
    };

    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const field = event.target.name;
    let registration = this.state.registration;
    registration[field] = event.target.value;

    if (registration.email === registration.emailConfirm || registration.email.trim() == ""  || registration.emailConfirm.trim() == "") {
      registration.errors.email = ''
    }
    else {
      registration.errors.email = 'Emails Dont Match.'
    }
    if (registration.password === registration.passwordConfirm) {
      registration.errors.password = ''
    } else {
      registration.errors.password = 'Passwords Dont Match.'
    }

    return this.setState({registration: registration});
  }

  generateId() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  handleSave(event){
    event.preventDefault();
    let registration = this.state.registration;
    registration.id = this.generateId();
    this.props.actions.createAccount(registration);
    this.context.router.history.push(`/account/edit/${registration.id}`);
    // this.context.router.history.push(`/edit-account/id-1`);
  }

  render () {
    return (
      <div className="genericPageWrap grey">
        <div className="account-forms-container">
          <header className="af-header">
            <h2 className="af-header-btn af-hb-grey">Sign-in</h2>
            <h2 className="af-header-btn">Register</h2>
          </header>
          <RegistrationForm
            errors={this.state.registration.errors}
            email={this.state.registration.email}
            emailConfirm={this.state.registration.emailConfirm}
            password={this.state.registration.password}
            passwordConfirm={this.state.registration.passwordConfirm}
            onSubmit={this.handleSave}
            onChange={this.handleChange} />
        </div>
      </div>
    );
  }
}

RegistrationPage.propTypes = {
  actions: PropTypes.object.isRequired,
  accounts: PropTypes.array.isRequired
};

RegistrationPage.contextTypes = {
  router: PropTypes.object
};

function mapStateToProps(state) {
  //normal parameter ownProps
  return {
    accounts: state.accounts
  }
}

function matchDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps,matchDispatchToProps)(RegistrationPage);



// WEBPACK FOOTER //
// ./src/components/registration/RegistrationPage.js